import { css } from "@emotion/react"
import { Button, Modal, Typography } from "matsuri-ui"
import { useState } from "react"
import { useTranslation } from "@/hooks/useTranslation"

interface ConfirmRejectDialogProps {
    onConfirmButtonClick: () => Promise<void>
    onClose: () => void
}

export const ConfirmRejectDialog = ({
    onConfirmButtonClick,
    onClose,
    ...props
}: ConfirmRejectDialogProps) => {
    const { t } = useTranslation()
    const [isLoading, setIsLoading] = useState(false)

    const handleConfirmClick = async () => {
        setIsLoading(true)
        try {
            await onConfirmButtonClick()
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <Modal
            {...props}
            body={
                <>
                    <Typography variant="h3" as="h3">
                        <pre>
                            {t("リクエストを却下します よろしいですか？")}
                        </pre>
                    </Typography>
                    <Typography
                        css={css`
                            margin-top: 8px;
                        `}
                    >
                        {t("この操作は取り消せません")}
                    </Typography>
                </>
            }
            footer={
                <footer
                    css={css`
                        display: flex;
                        gap: 8px;
                        justify-content: flex-end;
                    `}
                >
                    <Button
                        variant="text"
                        onClick={onClose}
                        disabled={isLoading}
                    >
                        {t("戻る")}
                    </Button>
                    <Button
                        variant="filled"
                        color="secondary"
                        onClick={handleConfirmClick}
                        disabled={isLoading}
                        loading={isLoading}
                    >
                        {t("却下")}
                    </Button>
                </footer>
            }
        />
    )
}
